import React from 'react';
import './App.css';
import { BrowserRouter, Routes, Route } from 'react-router-dom';
import Layout from './components/Layout';
import HomePage from './pages/HomePage';
import ArchivePage from './pages/ArchivePage';
import DossierPage from './pages/DossierPage';
import VideosPage from './pages/VideosPage';
import CIAPage from './pages/CIAPage';
import DisclosuresPage from './pages/DisclosuresPage';
import ExecutiveOrdersPage from './pages/ExecutiveOrdersPage';
import CovidPage from './pages/CovidPage';
import PdfViewerPage from './pages/PdfViewerPage';
import TimelinePage from './pages/TimelinePage';
import TestimoniesPage from './pages/TestimoniesPage';
import AboutPage from './pages/AboutPage';
import ScrollToTop from './components/ScrollToTop';
import { PortalDataProvider } from './hooks/usePortalData';
import { Toaster } from './components/ui/sonner';

function App() {
  return (
    <div className="App overflow-x-hidden">
      <PortalDataProvider>
        <BrowserRouter>
          <ScrollToTop />
          <Layout>
            <Routes>
              <Route path="/" element={<HomePage />} />
              <Route path="/archives" element={<ArchivePage />} />
              <Route path="/dossier/:id" element={<DossierPage />} />
              <Route path="/videos" element={<VideosPage />} />
              <Route path="/cia" element={<CIAPage />} />
              <Route path="/divulgations" element={<DisclosuresPage />} />
              <Route path="/ordres-executifs" element={<ExecutiveOrdersPage />} />
              <Route path="/covid" element={<CovidPage />} />
              <Route path="/covid/viewer/:code" element={<PdfViewerPage />} />
              <Route path="/chronologie" element={<TimelinePage />} />
              <Route path="/temoignages" element={<TestimoniesPage />} />
              <Route path="/a-propos" element={<AboutPage />} />
            </Routes>
          </Layout>
          <Toaster theme="dark" position="bottom-right" />
        </BrowserRouter>
      </PortalDataProvider>
    </div>
  );
}

export default App;
